import { render, staticRenderFns } from "./admin-template-desgin.vue?vue&type=template&id=69c62637&scoped=true&"
import script from "./admin-template-desgin.vue?vue&type=script&lang=ts&"
export * from "./admin-template-desgin.vue?vue&type=script&lang=ts&"
import style0 from "./admin-template-desgin.vue?vue&type=style&index=0&id=69c62637&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c62637",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Toast: require('/home/vsts/work/1/s/frontend/components/notification/toast.vue').default,SessionManagementNotification: require('/home/vsts/work/1/s/frontend/components/session-management-notification.vue').default})


/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VContainer,VMain})
